import dayjs from 'dayjs'
import { Driver } from '../types/driver'

export const filterByName = (drivers: Driver[], inputValue: string) => {
	let arrayOfInputCharacters = inputValue.toLocaleLowerCase().split('')
	let copyOfDrivers: [
		{
			companyName: string | null
			driverId: number
			driverName: string
			internalNumber: number
			points: number
		},
	] = [
		{
			companyName: null,
			driverId: 0,
			driverName: '',
			internalNumber: 0,
			points: 0,
		},
	]
	for (let i = 0; i < drivers.length; i++) {
		copyOfDrivers[i] = { ...drivers[i], points: 0 }
	}
	if (arrayOfInputCharacters.length === 0) return drivers
	if (arrayOfInputCharacters.length !== 0) {
		for (let i = 0; i < drivers.length; i++) {
			let driverNameCharacters = drivers[i].driverName.toLocaleLowerCase().split('')
			for (let j = 0; j < driverNameCharacters.length; j++) {
				let counter = 0
				if (arrayOfInputCharacters[j] === driverNameCharacters[j]) {
					counter += 1
					if (inputValue.length === counter) {
						copyOfDrivers[i].points = counter
					}
				}
			}
		}
		for (let i = 0; i < copyOfDrivers.length; i++) {
			let result = compare(inputValue.toLocaleLowerCase(), copyOfDrivers[i].driverName.toLocaleLowerCase())
			if (result) copyOfDrivers[i].points += 80
		}
		let filteredDrivers = copyOfDrivers.filter(item => item.points >= 10 + inputValue.length)
		return filteredDrivers.sort((a, b) => b.points - a.points)
	}
	return []
}

export const filterById = (drivers: Driver[], inputValue: string) => {
	let arrayOfInputNumbers = inputValue.toLocaleLowerCase().split('')
	let copyOfDrivers: [
		{
			companyName: string | null
			driverId: number
			driverName: string
			internalNumber: number
			points: number
		},
	] = [
		{
			companyName: null,
			driverId: 0,
			driverName: '',
			internalNumber: 0,
			points: 0,
		},
	]
	for (let i = 0; i < drivers.length; i++) copyOfDrivers[i] = { ...drivers[i], points: 0 }
	if (arrayOfInputNumbers.length === 0) return drivers
	if (arrayOfInputNumbers.length !== 0) {
		for (let i = 0; i < drivers.length; i++) {
			let internalNumber = String(drivers[i].internalNumber).toLocaleLowerCase().split('')
			for (let j = 0; j < internalNumber.length; j++) {
				let counter = 0
				if (arrayOfInputNumbers[j] === internalNumber[j]) {
					counter += 1
					if (inputValue.length === counter) {
						copyOfDrivers[i].points = counter
					}
				}
			}
		}
		for (let i = 0; i < copyOfDrivers.length; i++) {
			let result = compare(inputValue, String(copyOfDrivers[i].internalNumber))
			if (result) copyOfDrivers[i].points += 80
		}
		let filteredDrivers = copyOfDrivers.filter(item => item.points >= 10 + inputValue.length)
		let filteredDriversbyInternalNumber = filteredDrivers.sort((a, b) => a.internalNumber - b.internalNumber)
		return filteredDriversbyInternalNumber.sort((a, b) => b.points - a.points)
	}
	return []
}

function compare(itemOne: string, itemTwo: string): boolean {
	if (itemTwo.indexOf(itemOne) !== -1) {
		return true
	}
	return false
}

export function calculateFiltersDates(type: 'StartDate' | 'EndDate'): string {
	if (type === 'StartDate') {
		const today = dayjs(new Date())
		if (today.date() < 6) {
			// One month before, end of month
			return String(today.subtract(1, 'month').endOf('month').format('YYYY-MM-DD'))
		} else {
			// First day of current month
			return String(today.startOf('month').format('YYYY-MM-DD'))
		}
	} else if (type === 'EndDate') {
		return String(dayjs(dayjs()).format('YYYY-MM-DD'))
	} else {
		return ''
	}
}
